<template>
  <app-modal
    :modal-id="modalId"
    :title="title"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
    modal-size="large"
    modal-alignment="top"
  >
    <template slot="header">
      <h5 class="modal-title">{{ title }}</h5>
      <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>

    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        :data-url="
          selectedUrl
            ? `/versions-file/${inputs.id}`
            : `/versions-file`
        "
      >
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label class="mb-0">Tipo
                <b
                  class="text-danger ml-2"
                  style="font-size: 18px !important"
                  >*
                </b>
              </label>
                <app-input
                  id="inputs_type_document"
                  type="select"
                  v-model="inputs.type_document_id"
                  :list="typeDocumentList"
                  :required="true"
                />

            </div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <label class="mb-0">Área</label>
                <app-input
                  id="inputs_requesting_area"
                  type="select"
                  v-model="inputs.requesting_area"
                  :list="accreditationAreaList"
                  :required="true"
                />
            </div>
          </div>

          <div class="col-12 col-md-6">
            <div class="form-group">
              <label class="mb-0">Código
                <b
                  class="text-danger ml-2"
                  style="font-size: 18px !important"
                  >*
                </b>
              </label>
              <app-input
                type="text"
                v-model="inputs.code"
                placeholder="Ingrese Código"
                :required="true"
              />
            </div>
          </div>

          <div class="col-12 col-md-6">
            <div class="form-group">
              <label>Fecha de inicio de vigencia
                <b
                  class="text-danger ml-2"
                  style="font-size: 18px !important"
                  >*
                </b>
              </label>
              <app-input type="date" v-model="inputs.start_date_validity" :required="true"/>
            </div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <label class="mb-0">Archivo
                <b
                  class="text-danger ml-2"
                  style="font-size: 18px !important"
                  >*
                </b>
              </label>
              
              <app-input
                type="file"
                :label="inputs.file ? inputs.file.name : $t('upload_your_file')"
                v-model="inputs.file"
                v-if="!inputs.file_versions_file"
                :required="true"
              />

              <div class="mt-2">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(inputs, 'file_versions_file')"
                  v-if="inputs.file_versions_file"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>

                <button
                  type="submit"
                  class="btn btn-danger"
                  @click.prevent="confirmed('file_versions_file')"
                  v-if="inputs.file_versions_file"
                  :required="true"
                >
                  <app-icon name="trash-2" />
                  {{ $t("delete") }}
                </button>
              </div>
            </div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <label class="mb-0">Descripción
                <b
                  class="text-danger ml-2"
                  style="font-size: 18px !important"
                  >*
                </b>
              </label>
              <quill-editor v-model="inputs.description" :options="editorOption" />
            </div>
          </div>

          <div class="col-12" style="margin-top: 95px">
            <div class="form-group">
              <label class="mb-0">Activo</label>
              <app-input
                type="radio-buttons"
                v-model="inputs.is_active"
                :list="isActive"
              />
            </div>
          </div>

          <app-confirmation-modal
            v-if="deleteModal"
            modal-id="delete"
            @confirmed="confirm"
            @cancelled="cancelled"
          />
        </div>
      </form>
    </template>

    <template slot="footer">
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        Cerrar
      </button>
      <button type="button" class="btn btn-primary" @click="submit">
        Guardar
      </button>
    </template>
  </app-modal>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";
import { quillEditor } from "vue-quill-editor";

export default {
  components: { quillEditor },
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
    modalTitle: String,
    editModalTitle: String,
    accreditationAreaList: Array,
    typeDocumentList: Array,
  },
  data() {
    return {
      preloader: false,
      inputs: {
        is_active: 1,
      },
      info_file: null,
      deleteModal: false,
      modalId: "type-version-modal-add-edit",
      isActive: [
        {
          id: 1,
          value: "SI",
        },
        {
          id: 0,
          value: "NO",
        },
      ],
      editorOption: {
        placeholder: "Inserte el texto aquí..",
        modules: {
          toolbar: [
            [{ size: ["small", false, "large", "huge"] }],
            [
              "bold",
              "italic",
              "underline",
              "strike",
              { color: [] },
              { background: [] },
            ],
            [{ align: [] }],
            [
              { list: "ordered" },
              { list: "bullet" },
              { indent: "-1" },
              { indent: "+1" },
            ],
            ["clean"],
          ],
        },
      },
    };
  },
  computed: {
    title() {
      return this.selectedUrl ? this.editModalTitle : this.modalTitle;
    },
  },
  created() {
    this.inputs.start_date_validity = new Date();
    if (this.selectedUrl) {
      this.preloader = true;
    }
  },
  methods: {
    submit() {

      // if (!this.inputs.type_document_id || !this.inputs.code || !this.inputs.file || !this.inputs.description) {
      if (!this.inputs.type_document_id || !this.inputs.code || !this.inputs.description || (!this.inputs.file && !this.info_file)) {
        this.$toastr.e("Llenar los campos obligatorios");
      return;
      }

      if (!this.inputs.file && this.info_file && !this.inputs.file_versions_file) {
        this.$toastr.e("Llenar los campos obligatorios");
        return;
      }

      if (this.inputs.start_date_validity) {
        const d = this.inputs.start_date_validity;
        this.inputs.start_date_validity = [d.getFullYear(), d.getMonth() + 1, d.getDate()].join("-");
      }

      let formData = new FormData();
      for (const [key, value] of Object.entries(this.inputs)) {
        formData.append(key, value);
      }
      this.createOrUpdate(formData);
    },
    afterSuccess(response) {
      if (this.selectedUrl != "") {
        this.$toastr.s(this.$t("updated_success"));
      } else {
        this.$toastr.s(this.$t("created_success"));
      }
      this.$hub.$emit("reload-" + this.tableId);
    },
    afterSuccessFromGetEditData(response) {
      this.inputs = response.data;

      let date = new Date(response.data.start_date_validity);
          date.setDate(date.getDate() + 1);
      this.inputs.start_date_validity = date;
      this.info_file = 1;
      this.preloader = false;
    },
    afterFinalResponse() {
      this.closeModal();
      this.preloader = false;
    },
    afterError(res) {
      this.$toastr.e(res.data.message);
    },
    openTab(obj, fileName, key) {
      if (key) {
        const w = window.open(key, "_blank");
        w.focus();
      } else {
        const w = window.open(obj[fileName].path, "_blank");
        w.focus();
      }
    },
    confirmed(fileName) {
      this.inputs[fileName] = null;
      this.file = null;
    },

    cancelled() {
      this.deleteModal = false;
    },

    createOrUpdate(data) {
      
      this.axiosPost({
        url: "/versions-file",
        data,
      }).then((res) => {
        this.closeModal();
        if (res.status == 200) {
          if (this.inputs.id != null) {
            this.$toastr.s(this.$t("updated_success"));
          } else {
            this.$toastr.s(this.$t("created_success"));
          }
          this.$hub.$emit("reload-" + this.tableId);
        } else {
          if (this.inputs.id != null) {
            this.$toastr.e(this.$t("Error al intentar actualizar el registro"));
          } else {
            this.$toastr.e(this.$t("Error al intentar crear el registro"));
          }
        }
      });
    },
  },
};
</script>
